/** Pages that fill the app-main flex column (Plan, Organize). */
export const APP_PAGE_FILL_SX = {
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
  boxSizing: 'border-box',
};
